/** Low lashed-log ferry deck carrying removable cargo crates; its underside is the support surface. */
import { checkEnvelope, checkScope, el, n, partGroup } from '../../svg';
import type { PieceArt, PieceRecipe, ResolvedPalette } from '../../contract';
import { amount, grainRng, line } from './machinerySvg';
import { crate } from './yardSvg';
export interface FerryRaftParams { readonly crates: number }
export type FerryRaftRecipe = PieceRecipe<'mill.ferry_raft.v1', FerryRaftParams>;
export const FERRY_RAFT_FRAME = { w: 200, h: 60 } as const;
export const MILL_FERRY_RAFT: FerryRaftRecipe = {
  schema: 'hush.asset-recipe.v1', id: 'mill.ferry_raft.default.v1', generatorId: 'mill.ferry_raft.v1',
  seed: 20071014, paletteId: 'millrace_amber', params: { crates: 2 },
};
export function buildFerryRaft(recipe: FerryRaftRecipe, p: ResolvedPalette, scope: string): PieceArt {
  checkEnvelope(recipe, MILL_FERRY_RAFT.generatorId); checkScope(scope);
  const crates = amount(recipe.params.crates, 'crates', 0, 3, true), random = grainRng(recipe), parts: string[] = [];
  let logs = el('path', { d: 'M9 48H191V56Q189 60 181 60H19Q10 60 9 56Z', fill: p.woodShadow });
  for (let i = 0; i < 9; i++) {
    const x = 14 + i * 21;
    logs += el('ellipse', { cx: x, cy: 52, rx: 10, ry: 6, fill: p.woodBase, stroke: p.outline, 'stroke-width': 1 })
      + el('path', { d: `M${x - 5} 54Q${x - 7} 49 ${x} 48Q${x + 6} 49 ${x + 5} 53`, fill: 'none', stroke: p.woodLight, 'stroke-width': 0.8 });
  }
  let deck = el('path', { d: 'M9 36L188 36L195 45L7 45Z', fill: p.woodBase, stroke: p.outline, 'stroke-width': 1.2 });
  for (let i = 0; i < 4; i++) {
    const y = 37 + i * 2.1;
    deck += line(12, y, 187, y, i % 2 ? p.woodLight : p.woodShadow, 0.8);
  }
  for (const x of [31, 163]) deck += el('path', { d: `M${x} 36L${x + 5} 45V56Q${x + 3} 59 ${x} 56Z`, fill: p.paperShadow })
    + line(x + 1, 38, x + 3, 55, p.paperLight, 1);
  for (let i = 0; i < 8; i++) deck += line(17 + i * 21, 42, 22 + i * 21, 42 + random(`grain.${i}`) * 1.5, p.woodShadow, 0.7);
  let cargo = '';
  for (let i = 0; i < crates; i++) cargo += crate(37 + i * 43, 12, 24, p);
  const tow = el('path', { d: `M12 39Q${n(10 + random('tow') * 2)} 29 20 30Q27 31 22 37`, fill: 'none', stroke: p.paperLight, 'stroke-width': 1.6 });
  const body = partGroup(parts, 'raft-log-floats', logs) + partGroup(parts, 'raft-plank-deck', deck)
    + partGroup(parts, 'raft-cargo', cargo || el('g', { 'data-empty': 'true' })) + partGroup(parts, 'raft-tow-loop', tow);
  return { frame: FERRY_RAFT_FRAME, body, anchors: { support: { x: 100, y: 60 }, tow: { x: 20, y: 30 }, deck: { x: 100, y: 36 } }, parts, openings: [] };
}
